/**
 * 参考: 日本のIP電話 - Wikipedia
 * @see https://ja.wikipedia.org/wiki/%E6%97%A5%E6%9C%AC%E3%81%AEIP%E9%9B%BB%E8%A9%B1
 */
const ipPhoneRegexp = new RegExp(/^050[-]?\d{4}[-]?\d{4}$/);

const ipPhone = (value: string) => {
  if (value === "") {
    return true;
  }

  return ipPhoneRegexp.test(value);
};

export default ipPhone;
